import type { GameSession } from './session'

let active: GameSession | null = null
let onRestart: (() => void) | null = null

/** Lets React controls reach the session the scene currently owns. */
export function attachSession(session: GameSession, restart: () => void): void {
  active = session
  onRestart = restart
}

export function detachSession(): void {
  active = null
  onRestart = null
}

export function getSession(): GameSession | null {
  return active
}

export function restartSession(): void {
  onRestart?.()
}
